export default "__VITE_ASSET__467fe201__"